"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TgglReporting = exports.PACKAGE_VERSION = void 0;
var apiCall_1 = require("./apiCall");
exports.PACKAGE_VERSION = '1.17.2';
var constantCase = function (str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .replace(/[\W_]+/g, '_')
        .toUpperCase();
};
var TgglReporting = /** @class */ (function () {
    function TgglReporting(_a) {
        var app = _a.app, appPrefix = _a.appPrefix, apiKey = _a.apiKey, url = _a.url, baseUrl = _a.baseUrl, reportInterval = _a.reportInterval;
        this.disabled = false;
        this.flagsToReport = {};
        this.receivedPropertiesToReport = {};
        this.receivedValuesToReport = {};
        this.app = app !== null && app !== void 0 ? app : null;
        this.appPrefix = appPrefix !== null && appPrefix !== void 0 ? appPrefix : null;
        this.apiKey = apiKey !== null && apiKey !== void 0 ? apiKey : null;
        this.reportInterval = reportInterval !== null && reportInterval !== void 0 ? reportInterval : 2000;
        if (url) {
            this.url = url;
        }
        else if (baseUrl) {
            this.url = baseUrl + '/report';
        }
        else {
            this.url = 'https://api.tggl.io/report';
        }
        this.sendReport();
    }
    TgglReporting.prototype.disable = function () {
        this.disabled = true;
    };
    TgglReporting.prototype.sendReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payload, flagsToReport, _a, _b, _c, clientId, flags, receivedProperties, receivedValues_1, data, pageSize, i, error_1;
            var e_1, _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 7, , 8]);
                        payload = {};
                        if (Object.keys(this.flagsToReport).length) {
                            flagsToReport = __assign({}, this.flagsToReport);
                            this.flagsToReport = {};
                            payload.clients = [];
                            try {
                                for (_a = __values(Object.entries(flagsToReport)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    _c = __read(_b.value, 2), clientId = _c[0], flags = _c[1];
                                    payload.clients.push({
                                        id: clientId || undefined,
                                        flags: Object.entries(flags).reduce(function (acc, _a) {
                                            var _b = __read(_a, 2), key = _b[0], value = _b[1];
                                            acc[key] = __spreadArray([], __read(value.values()), false);
                                            return acc;
                                        }, {}),
                                    });
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        if (Object.keys(this.receivedPropertiesToReport).length) {
                            receivedProperties = this.receivedPropertiesToReport;
                            this.receivedPropertiesToReport = {};
                            payload.receivedProperties = receivedProperties;
                        }
                        if (!Object.keys(this.receivedValuesToReport).length) return [3 /*break*/, 4];
                        receivedValues_1 = this.receivedValuesToReport;
                        this.receivedValuesToReport = {};
                        data = Object.keys(receivedValues_1).reduce(function (acc, key) {
                            var e_2, _a;
                            try {
                                for (var _b = __values(Object.keys(receivedValues_1[key])), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var value = _c.value;
                                    var label = receivedValues_1[key][value];
                                    if (label) {
                                        acc.push([key, value, label]);
                                    }
                                    else {
                                        acc.push([key, value]);
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            return acc;
                        }, []);
                        pageSize = 2000;
                        payload.receivedValues = data.slice(0, pageSize).reduce(function (acc, cur) {
                            var _a;
                            var _b;
                            (_a = acc[_b = cur[0]]) !== null && _a !== void 0 ? _a : (acc[_b] = []);
                            acc[cur[0]].push(cur.slice(1).map(function (v) { return v.slice(0, 240); }));
                            return acc;
                        }, {});
                        i = pageSize;
                        _e.label = 1;
                    case 1:
                        if (!(i < data.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0, apiCall_1.apiCall)({
                                url: this.url,
                                apiKey: this.apiKey,
                                method: 'post',
                                body: {
                                    receivedValues: data.slice(i, i + pageSize).reduce(function (acc, cur) {
                                        var _a;
                                        var _b;
                                        (_a = acc[_b = cur[0]]) !== null && _a !== void 0 ? _a : (acc[_b] = []);
                                        acc[cur[0]].push(cur.slice(1).map(function (v) { return v.slice(0, 240); }));
                                        return acc;
                                    }, {}),
                                },
                            })];
                    case 2:
                        _e.sent();
                        _e.label = 3;
                    case 3:
                        i += pageSize;
                        return [3 /*break*/, 1];
                    case 4:
                        if (!Object.keys(payload).length) return [3 /*break*/, 6];
                        return [4 /*yield*/, (0, apiCall_1.apiCall)({
                                url: this.url,
                                apiKey: this.apiKey,
                                method: 'post',
                                body: payload,
                            })];
                    case 5:
                        _e.sent();
                        _e.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _e.sent();
                        return [3 /*break*/, 8];
                    case 8:
                        if (!this.disabled) {
                            setTimeout(function () {
                                _this.sendReport();
                            }, this.reportInterval);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TgglReporting.prototype.reportFlag = function (slug, data) {
        var _a, _b;
        try {
            this.incrementFlag(data, "".concat((_a = this.appPrefix) !== null && _a !== void 0 ? _a : '').concat(this.app && this.appPrefix ? '/' : '').concat((_b = this.app) !== null && _b !== void 0 ? _b : ''), slug);
        }
        catch (error) {
            // Do nothing
        }
    };
    TgglReporting.prototype.reportContext = function (context) {
        var e_3, _a;
        var _b, _c;
        var _d;
        try {
            var now = Math.round(Date.now() / 1000);
            var _loop_1 = function (key) {
                if (this_1.receivedPropertiesToReport[key]) {
                    this_1.receivedPropertiesToReport[key][1] = now;
                }
                else {
                    this_1.receivedPropertiesToReport[key] = [now, now];
                }
                if (typeof context[key] === 'string' && context[key]) {
                    var constantCaseKey = constantCase(key).replace(/_I_D$/, '_ID');
                    var labelKeyTarget_1 = constantCaseKey.endsWith('_ID')
                        ? constantCaseKey.replace(/_ID$/, '_NAME')
                        : null;
                    var labelKey = labelKeyTarget_1
                        ? (_b = Object.keys(context).find(function (k) { return constantCase(k) === labelKeyTarget_1; })) !== null && _b !== void 0 ? _b : null
                        : null;
                    (_c = (_d = this_1.receivedValuesToReport)[key]) !== null && _c !== void 0 ? _c : (_d[key] = {});
                    this_1.receivedValuesToReport[key][context[key]] =
                        labelKey && typeof context[labelKey] === 'string'
                            ? context[labelKey] || null
                            : null;
                }
            };
            var this_1 = this;
            try {
                for (var _e = __values(Object.keys(context)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var key = _f.value;
                    _loop_1(key);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        catch (error) {
            // Do nothing
        }
    };
    TgglReporting.prototype.mergeReport = function (report) {
        var e_4, _a, e_5, _b, e_6, _c, e_7, _d, e_8, _e, e_9, _f;
        var _g, _h, _j;
        var _k;
        if (!report || typeof report !== 'object' || Array.isArray(report)) {
            return;
        }
        try {
            if (report.receivedProperties) {
                try {
                    for (var _l = __values(Object.entries(report.receivedProperties)), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var _o = __read(_m.value, 2), key = _o[0], _p = __read(_o[1], 2), min = _p[0], max = _p[1];
                        if (this.receivedPropertiesToReport[key]) {
                            this.receivedPropertiesToReport[key][0] = Math.min(this.receivedPropertiesToReport[key][0], min);
                            this.receivedPropertiesToReport[key][1] = Math.max(this.receivedPropertiesToReport[key][1], max);
                        }
                        else {
                            this.receivedPropertiesToReport[key] = [min, max];
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_a = _l.return)) _a.call(_l);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
            if (report.receivedValues) {
                try {
                    for (var _q = __values(Object.entries(report.receivedValues)), _r = _q.next(); !_r.done; _r = _q.next()) {
                        var _s = __read(_r.value, 2), key = _s[0], values = _s[1];
                        try {
                            for (var values_1 = (e_6 = void 0, __values(values)), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                                var _t = __read(values_1_1.value, 2), value = _t[0], label = _t[1];
                                (_g = (_k = this.receivedValuesToReport)[key]) !== null && _g !== void 0 ? _g : (_k[key] = {});
                                this.receivedValuesToReport[key][value] =
                                    (_h = label !== null && label !== void 0 ? label : this.receivedValuesToReport[key][value]) !== null && _h !== void 0 ? _h : null;
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (values_1_1 && !values_1_1.done && (_c = values_1.return)) _c.call(values_1);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_r && !_r.done && (_b = _q.return)) _b.call(_q);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            if (report.clients) {
                try {
                    for (var _u = __values(report.clients), _v = _u.next(); !_v.done; _v = _u.next()) {
                        var client = _v.value;
                        try {
                            for (var _w = (e_8 = void 0, __values(Object.entries(client.flags))), _x = _w.next(); !_x.done; _x = _w.next()) {
                                var _y = __read(_x.value, 2), slug = _y[0], values = _y[1];
                                try {
                                    for (var values_2 = (e_9 = void 0, __values(values)), values_2_1 = values_2.next(); !values_2_1.done; values_2_1 = values_2.next()) {
                                        var data = values_2_1.value;
                                        this.incrementFlag(data, (_j = client.id) !== null && _j !== void 0 ? _j : '', slug);
                                    }
                                }
                                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                                finally {
                                    try {
                                        if (values_2_1 && !values_2_1.done && (_f = values_2.return)) _f.call(values_2);
                                    }
                                    finally { if (e_9) throw e_9.error; }
                                }
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (_x && !_x.done && (_e = _w.return)) _e.call(_w);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_v && !_v.done && (_d = _u.return)) _d.call(_u);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
        }
        catch (error) {
            // Do nothing
        }
    };
    TgglReporting.prototype.incrementFlag = function (data, clientId, slug) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j, _k;
        (_a = (_j = this.flagsToReport)[clientId]) !== null && _a !== void 0 ? _a : (_j[clientId] = {});
        var key = "".concat(data.active ? '1' : '0').concat(JSON.stringify((_b = data.value) !== null && _b !== void 0 ? _b : null)).concat(JSON.stringify((_c = data.default) !== null && _c !== void 0 ? _c : null));
        (_d = (_k = this.flagsToReport[clientId])[slug]) !== null && _d !== void 0 ? _d : (_k[slug] = new Map());
        var value = (_e = this.flagsToReport[clientId][slug].get(key)) !== null && _e !== void 0 ? _e : this.flagsToReport[clientId][slug]
            .set(key, {
            active: data.active,
            value: (_f = data.value) !== null && _f !== void 0 ? _f : null,
            default: (_g = data.default) !== null && _g !== void 0 ? _g : null,
            count: 0,
        })
            .get(key);
        value.count += (_h = data.count) !== null && _h !== void 0 ? _h : 1;
    };
    return TgglReporting;
}());
exports.TgglReporting = TgglReporting;
